import { create } from 'zustand';

export interface CustomField {
    id: string;
    name: string;
}

interface CustomFieldsStore {
    selectedCustomField: CustomField | null;
    selectedCustomFields: CustomField[];

    setSelectedCustomField: (field: CustomField | null) => void;
    addCustomField: (field: CustomField) => void;
    removeCustomField: (id: string) => void;
    clearCustomFields: () => void;
}

export const useCustomFieldsStore = create<CustomFieldsStore>((set, get) => ({
    selectedCustomField: null,
    selectedCustomFields: [],

    setSelectedCustomField: (field) => {
        set({ selectedCustomField: field });
    },

    addCustomField: (field) => {
        const current = get().selectedCustomFields;

        const exists = current.some((f) => f.id === field.id);
        if (!exists) {
            set({ selectedCustomFields: [...current, field] });
        }
    },

    removeCustomField: (id) => {
        const filtered = get().selectedCustomFields.filter((f) => f.id !== id);
        set({ selectedCustomFields: filtered });
    },

    clearCustomFields: () => {
        set({
            selectedCustomField: null,
            selectedCustomFields: [],
        });
    },
}));
